import { Bell } from "lucide-react";
import SideBar from "./SideBar";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "src/redux/reducers/authSlice";
import { Menu, MenuItem, Button } from "@mui/material";
import DownIcon from "@mui/icons-material/ArrowDropDown";
import { useState } from "react";

const HRDashboardLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="flex h-screen bg-bg">

      <SideBar />

      <div className="flex-1 flex flex-col">
        <header className="flex items-center justify-end bg-white px-[26px] py-[14px] shadow-md">
          <div className="flex items-center gap-4">
            <div className="flex gap-1 items-center text-sm">
              <span>Notifications</span>
              <button>
                <Bell size={20} />
              </button>
            </div>

            {/* Profile dropdown */}
            <Button
              id="profile-button"
              aria-controls={open ? "profile-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
              style={{
                display: "flex",
                alignItems: "center",
                textTransform: "none",
              }}
            >
              <div className="flex flex-col text-right mr-2">
                <span className="text-lg font-semibold">HR</span>
              </div>
              <DownIcon />
            </Button>
            <Menu
              id="profile-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() => {
                  handleClose();
                  dispatch(logout());
                  navigate("/");
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-6 pt-0 overflow-y-auto">
          <Outlet/>
        </main>
      </div>
    </div>
  );
};

export default HRDashboardLayout;
